import { render, staticRenderFns } from "./gb-whatsapp-app-not-installed.vue?vue&type=template&id=03a61190&scoped=true"
import script from "./gb-whatsapp-app-not-installed.vue?vue&type=script&lang=js"
export * from "./gb-whatsapp-app-not-installed.vue?vue&type=script&lang=js"
import style0 from "./gb-whatsapp-app-not-installed.vue?vue&type=style&index=0&id=03a61190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a61190",
  null
  
)

export default component.exports